import {
  INVALIDATE_SUB_DISCOUNT_OUTLETS,
  REQUEST_SUB_DISCOUNT_OUTLETS,
  RECEIVE_SUB_DISCOUNT_OUTLETS,
  INVALIDATE_SUB_BANDS,
  REQUEST_SUB_BANDS,
  RECEIVE_SUB_BANDS,
  INVALIDATE_COMMUNITY_NOTICES,
  REQUEST_COMMUNITY_NOTICES,
  RECEIVE_COMMUNITY_NOTICES,
  INVALIDATE_TAXONOMIES,
  REQUEST_TAXONOMIES,
  RECEIVE_TAXONOMIES
} from './actions'

export function taxonomies(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_TAXONOMIES:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_TAXONOMIES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_TAXONOMIES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.taxonomies,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function subBands(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_SUB_BANDS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_SUB_BANDS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_SUB_BANDS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.subBands,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}
export function subDiscountOutlets(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_SUB_DISCOUNT_OUTLETS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_SUB_DISCOUNT_OUTLETS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_SUB_DISCOUNT_OUTLETS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.subDiscountOutlets,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function communityNotices(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_COMMUNITY_NOTICES:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_COMMUNITY_NOTICES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_COMMUNITY_NOTICES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.communityNotices,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}
